"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const roomCreateStore_1 = require("@/room/room_create/roomCreateStore");
const react_i18next_1 = require("react-i18next");
const webview_app_1 = require("@/webview_app");
const api_1 = require("@/api");
const svgs_1 = require("@@/assets/svgs");
const functions_1 = require("@/common/functions");
const errors_1 = require("@/common/errors");
const material_ui_confirm_1 = require("material-ui-confirm");
const CircularProgress_1 = __importDefault(require("@mui/material/CircularProgress"));
const Button_1 = __importDefault(require("@mui/material/Button"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
function default_1({ roomId, productId, }) {
    const targetProduct = (0, react_redux_1.useSelector)((state) => state.productData).find((product) => product.id === productId);
    const photos = targetProduct ? targetProduct.images : [];
    const photosLength = photos.length;
    const [uploading, setUploading] = (0, react_1.useState)(false);
    const dispatch = (0, react_redux_1.useDispatch)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const confirm = (0, material_ui_confirm_1.useConfirm)();
    const postProductImage = (compressedImg) => __awaiter(this, void 0, void 0, function* () {
        const formData = new FormData();
        formData.append('images', compressedImg);
        yield (0, api_1.postFormData)(`/api/v1/store/room/${roomId}/product/${productId}/image`, formData)
            .then(res => {
            if (res.status === 201 || res.status === 206) {
                dispatch((0, roomCreateStore_1.setProductImage)({ productId, images: res.data.result.images }));
            }
        })
            .catch(err => {
            var _a, _b, _c, _d;
            const errorStatus = (_a = err.response) === null || _a === void 0 ? void 0 : _a.status;
            const errorCode = (_d = (_c = (_b = err.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.meta) === null || _d === void 0 ? void 0 : _d.alert_type;
            if (errorCode === 40001) {
                confirm({
                    description: t('앗 이미지 업로드를 실패했어요. 잠시 뒤에 시도해주세요.'),
                    cancellationButtonProps: { style: { display: 'none' } },
                });
            }
            else {
                (0, errors_1.commonErrorConfirm)({ confirm, errorCode: errorCode || errorStatus });
            }
        })
            .finally(() => setUploading(false));
    });
    const uploadProductImage = (files) => {
        const imageFile = files[0];
        setUploading(true);
        (0, functions_1.compressImageFile)({
            imageFile,
            maxWidth: 1500,
            quality: 0.7,
            onCompressSuccess: postProductImage,
            onCompressError: () => setUploading(false),
        });
    };
    const Photo = (photo) => {
        const photoSrc = photo.img_url;
        const photoId = String(photo.id);
        const [deleting, setDeleting] = (0, react_1.useState)(false);
        const deletePhoto = (photoId) => __awaiter(this, void 0, void 0, function* () {
            (0, functions_1.tempDisableClick)(1500);
            setDeleting(true);
            yield (0, api_1.deleteData)(`/api/v1/store/room/${roomId}/product/${productId}/image/${photoId}`)
                .then((res) => __awaiter(this, void 0, void 0, function* () {
                if (res.status === 200) {
                    dispatch((0, roomCreateStore_1.setProductImage)({ productId, images: res.data.result.images }));
                }
                else {
                    setDeleting(false);
                    alert((0, errors_1.commonErrorMsg)());
                }
            }))
                .catch(err => {
                var _a, _b, _c, _d;
                const errorStatus = (_a = err.response) === null || _a === void 0 ? void 0 : _a.status;
                const errorCode = (_d = (_c = (_b = err.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.meta) === null || _d === void 0 ? void 0 : _d.alert_type;
                if (errorCode === 40001) {
                    confirm({
                        description: t('앗 이미지 삭제를 실패했어요. 잠시 뒤에 시도해주세요.'),
                        cancellationButtonProps: { style: { display: 'none' } },
                    });
                }
                else {
                    (0, errors_1.commonErrorConfirm)({ confirm, errorCode: errorCode || errorStatus });
                }
                setDeleting(false);
            });
        });
        return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "photo_wrapper", css: {
                position: 'relative',
                width: '56px',
                height: '56px',
                '&:after': (0, functions_1.afterImgWrapper)({ borderRadius: '8px' }),
            } }, { children: [deleting ? ((0, jsx_runtime_1.jsx)("span", Object.assign({ css: {
                        position: 'absolute',
                        top: '-4px',
                        right: '-4px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '16px',
                        height: '16px',
                        borderRadius: '8px',
                        backgroundColor: 'var(--gray-20)',
                    } }, { children: (0, jsx_runtime_1.jsx)(CircularProgress_1.default, { size: 10, color: "info", thickness: 8 }) }))) : ((0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ css: {
                        position: 'absolute',
                        top: '-8px',
                        right: '-8px',
                    }, onClick: () => deletePhoto(photoId) }, { children: (0, jsx_runtime_1.jsx)(svgs_1.XCircleGraySvg, { css: {
                            width: '16px',
                            height: '16px',
                            borderRadius: '50%',
                            backdropFilter: 'blur(10px)',
                        } }) }))), (0, jsx_runtime_1.jsx)("img", { src: (0, functions_1.getCdnUrl)(photoSrc), alt: photoId, css: {
                        width: '100%',
                        height: '100%',
                        borderRadius: '8px',
                        backgroundColor: 'var(--surface-bg)',
                        objectFit: 'cover',
                    } })] })));
    };
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ css: { display: 'flex', columnGap: '12px' } }, { children: [(0, jsx_runtime_1.jsxs)(Button_1.default, Object.assign({ component: "label", sx: {
                    display: 'flex',
                    flexDirection: 'column',
                    width: '56px',
                    height: '56px',
                    p: 0,
                    border: '1px solid var(--gray-10)',
                    borderRadius: '8px',
                    bgcolor: 'var(--surface-bg) !important',
                    color: 'var(--gray-40)',
                } }, { children: [uploading ? ((0, jsx_runtime_1.jsx)(CircularProgress_1.default, { size: 20, thickness: 4, color: "inherit" })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(svgs_1.CameraIconGraySvg, { css: { width: '20px', height: '20px' } }), (0, jsx_runtime_1.jsxs)("span", Object.assign({ className: "caption1" }, { children: ["(", photosLength, "/1)"] }))] })), (0, jsx_runtime_1.jsx)("input", { id: `product_photo_input_${productId}`, name: "file", type: "file", hidden: true, disabled: uploading || photosLength >= 1, onChange: e => {
                            if (e.target.files) {
                                uploadProductImage(e.target.files);
                            }
                        }, onClick: e => {
                            (0, webview_app_1.askPhotoPermissionsToWVA)(`product_photo_input_${productId}`, e);
                            e.currentTarget.value = '';
                        } })] })), photosLength > 0 &&
                photos.map((photo, idx) => ((0, jsx_runtime_1.jsx)(Photo, Object.assign({}, photo), `product_photo_${photo.id}_${idx}`)))] })));
}
exports.default = default_1;
